// ==========================================
// NOUVELLES ICÔNES - SERVICES & AVANTAGES
// ==========================================

// Icône Transport Aérien Express (Avion en papier dynamique)
export const AirIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M22 2L11 13" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
);

// Icône Transport Maritime Économique (Cargo naviguant sur les vagues)
export const SeaIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M4 14h16l1.5-6H2.5L4 14z" />
        <path d="M7 8V4h10v4" />
        <path d="M12 8V4" />
        <path d="M2 18s2-2 4-2 4 2 6 2 4-2 6-2 4 2 4 2" />
    </svg>
);

// Icône Groupeur / LCL (Colis empilés)
export const GroupageIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <rect x="3" y="14" width="8" height="7" rx="1" />
        <path d="M3 17h8" />
        <rect x="13" y="14" width="8" height="7" rx="1" />
        <path d="M13 17h8" />
        <rect x="8" y="5" width="8" height="7" rx="1" />
        <path d="M8 8h8" />
    </svg>
);

// Icône Boutique Détaillée (Devanture de magasin avec store)
export const StoreIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M3 9h18v2a2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-2-2z" />
        <path d="M4 21V11" />
        <path d="M20 21V11" />
        <path d="M2 9L4 4h16l2 5" />
        <rect x="9" y="13" width="6" height="8" rx="1" />
    </svg>
);

// Icône Service Premium (Couronne minimaliste)
export const PremiumIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M2 20h20" />
        <path d="M3 16l-1-9 5 3 5-7 5 7 5-3-1 9z" />
    </svg>
);

// Icône Présence (Carte dépliée avec points de connexion)
export const PresenceIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M3 6l6-4 6 4 6-4v14l-6 4-6-4-6 4V6z" />
        <path d="M9 2v14" />
        <path d="M15 6v14" />
        <circle cx="9" cy="8" r="1.5" fill={color} stroke="none" />
        <circle cx="15" cy="14" r="1.5" fill={color} stroke="none" />
        <path d="M10 9l4 4" strokeDasharray="2 2" />
    </svg>
);

// Icône Support (Casque micro)
export const SupportIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M3 15h2a2 2 0 0 0 2-2v-4a7 7 0 0 1 14 0v4a2 2 0 0 0 2 2h2" />
        <path d="M21 15v3a3 3 0 0 1-3 3h-4" />
        <rect x="2" y="11" width="4" height="6" rx="1" />
        <rect x="18" y="11" width="4" height="6" rx="1" />
    </svg>
);

// Icône Temps Réel (Horloge avec flèche d'actualisation)
export const TrackingIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
        <path d="M21 3v5h-5" />
        <path d="M12 7v5l3 3" />
    </svg>
);

// Icône Rapidité (Éclair dynamique)
export const SpeedIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
);

// Icône Prix Compétitifs (Étiquette de prix avec attache)
export const PriceIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
        <circle cx="7" cy="7" r="1.5" />
    </svg>
);

// Icône Sécurité (Bouclier validé)
export const SecurityIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
    </svg>
);

// ==========================================
// NOUVELLES ICÔNES - SERVICES & AVANTAGES
// ==========================================

// Icône Transport Aérien Express (Avion en papier dynamique)
export const AirExpressIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M22 2L11 13" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
);

// Icône Transport Maritime Économique (Cargo naviguant sur les vagues)
export const SeaEconomyIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M4 14h16l1.5-6H2.5L4 14z" />
        <path d="M7 8V4h10v4" />
        <path d="M12 8V4" />
        <path d="M2 18s2-2 4-2 4 2 6 2 4-2 6-2 4 2 4 2" />
    </svg>
);


// Icône Boutique Détaillée (Devanture de magasin avec store)
export const StoreDetailedIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M3 9h18v2a2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-2-2z" />
        <path d="M4 21V11" />
        <path d="M20 21V11" />
        <path d="M2 9L4 4h16l2 5" />
        <rect x="9" y="13" width="6" height="8" rx="1" />
    </svg>
);



// Icône Temps Réel (Horloge avec flèche d'actualisation)
export const RealTimeIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
        <path d="M21 3v5h-5" />
        <path d="M12 7v5l3 3" />
    </svg>
);

export const CustomsIcon = ({ size = 50, color = "currentColor", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
        <path d="M9 14l2 2 4-4" />
    </svg>
);


// Ajouter ces icônes dans ServiceIcons.jsx

// Icône Trophée pour les années d'expérience
export const TrophyIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 2H18V6C18 8 16 10 12 10C8 10 6 8 6 6V2Z" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M6 2H3V6C3 8 5 10 8 10" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M18 2H21V6C21 8 19 10 16 10" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M12 10V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 22H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M12 16V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

// Icône Boîte pour les colis
export const BoxIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 7L12 3L21 7" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M3 7V17L12 21L21 17V7" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M12 12L12 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M3 7L12 12L21 7" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M8 9L16 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

// Icône Globe pour les pays
export const GlobeIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M12 3C10 5 9 8 9 12C9 16 10 19 12 21" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M12 3C14 5 15 8 15 12C15 16 14 19 12 21" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M3 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
);

// Icône Étoile pour la satisfaction
export const StarIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L15 9H22L16 14L19 21L12 16.5L5 21L8 14L2 9H9L12 2Z" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <path d="M12 6L13.5 10.5H18L14.5 13.5L16 18L12 15.5L8 18L9.5 13.5L6 10.5H10.5L12 6Z" fill="currentColor" opacity="0.3" />
    </svg>
);